import React from 'react';
import { ZITONEO_PUBLIC_WEBSITE_URL_HOTEL_DETAIL } from '../../../../utils/zitoneoServicesUtils';
import SidebarSection from '../../../../components/sideBar/SidebarSection';
import { useZitoneoSettingsChecks } from '../../../../contexts/ZitoneoContentContext';
import useTranslate from '../../../../../../customHooks/useTranslate';
import Icon from '../../../../../../muiComponents/Icon';
import CopyOnHover from '../../../../../ownerPortal/components/CopyOnHover';

const YourWebsiteLink = () => {
    const translate = useTranslate();
    const { hasURLs, hasPrimaryURL, primaryIsEnabled, published, primaryURL } =
        useZitoneoSettingsChecks();

    const allComplete =
        hasURLs && hasPrimaryURL && primaryIsEnabled && published;
    const hasURLIssue = hasURLs && (!hasPrimaryURL || !primaryIsEnabled);

    const isWebsiteVisible =
        process.env.REACT_APP_ZITONEO_PUBLIC_WEBSITE_IS_VISIBLE === 'true';

    const renderContent = () => {
        if (!isWebsiteVisible) {
            return (
                <p className='your-website --placeholder'>
                    {translate('zitoneo_website_coming_soon')}
                </p>
            );
        }

        if (allComplete && primaryURL) {
            const url = `${ZITONEO_PUBLIC_WEBSITE_URL_HOTEL_DETAIL}${primaryURL.Path}`;
            return (
                <div className='your-website --live'>
                    <p className='your-website__live-label'>
                        {translate('live_at')}
                    </p>
                    <div className='your-website__live-link-row'>
                        <a
                            href={url}
                            target='_blank'
                            rel='noopener noreferrer'
                            className='your-website__live-link'
                        >
                            ↗ {primaryURL.Path}
                        </a>
                        <CopyOnHover
                            textToCopy={url}
                            className='overflow-hidden gap-5'
                        >
                            <p className='your-website__live-url'>{url}</p>
                        </CopyOnHover>
                    </div>
                    <p className='your-website__warning-note'>
                        <Icon
                            iconName='InfoOutlined'
                            className='your-website__info-icon'
                            style={{ fontSize: '14px', marginRight: '4px' }}
                        />
                        {translate('url_warning_note')}
                    </p>
                </div>
            );
        }

        if (hasURLIssue) {
            const message = !hasPrimaryURL
                ? translate('set_primary_url_to_see_live')
                : translate('enable_primary_url_to_see_live');
            return <p className='your-website --placeholder'>{message}</p>;
        }

        return (
            <p className='your-website --placeholder'>
                {translate('complete_checks_to_see_live')}
            </p>
        );
    };

    return (
        <SidebarSection title='your_website'>{renderContent()}</SidebarSection>
    );
};

export default YourWebsiteLink;
